import { WidgetInstance } from "mobx-store/stores/customScreens/types";
import { ValidationOptionsKeys } from "screens/addEditCustomScreen/types";
import { WidgetSliderInstance } from "../SliderWidgetCard/types";
import { ValidationSchema } from "../validation.helper";

export interface Props {
  focusedWidgetData: WidgetInstance | WidgetSliderInstance;
  focusedWidget: null | string | number;
  handleChangeData: (paramName: string, value: string) => void;
  removeFocusedWidget: () => void;
  handleMultipleChangeData: (params: {}) => void;
}

export enum verticalWidgetType {
  STATIC="static",
  INTENAL="internal",
  EXTERNAL="external",
};

export const verticalWidgetValidation: ValidationSchema =  {
  title: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  description: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  imageURL: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  colorPalette: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  dismissButton: [],
  actionButtonTitle: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  actionButtonType: [{
          validation: [ValidationOptionsKeys.REQUIRED],    
  }],
  actionButtonExternalLink: [{
    validation: [ValidationOptionsKeys.REQUIRED],
    case: {
      key: 'actionButtonType',
      value: verticalWidgetType.EXTERNAL
    }
  }],
  actionButtonParams: [],
  actionButtonRedirect: [{
      validation: [ValidationOptionsKeys.REQUIRED],
      case: {
        key: 'actionButtonType',
        value: verticalWidgetType.INTENAL
      }
  }],
  actionButtonEntityId: [],
  actionButtonStaticTitle: [
    {
      validation: [ValidationOptionsKeys.REQUIRED],
      case: {
        key: 'actionButtonType',
        value: verticalWidgetType.STATIC
      }
    }
  ],
  actionButtonStaticDescription: [
    {
      validation: [ValidationOptionsKeys.REQUIRED],
      case: {
        key: 'actionButtonType',
        value: verticalWidgetType.STATIC
      }
    }
  ],
}